import { Middleware } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { clearSynth, removeFromSynth, setNextSynth, setSynthResult } from '../slices/bloodlineSlice';
import { setCharacterData, setCharacterPartial } from '../slices/characterSlice';
import { SERVER_CONFIG } from '../util/serverConfig';
export const bloodlineUpdater: Middleware<{}, RootState> = (store) => (next) => (action) => {
  const previous = store.getState().character.bloodlines.souls;
  const result = next(action);
  if ((action.type === setCharacterData.type || action.type === setCharacterPartial.type) && previous !== store.getState().character.bloodlines.souls) store.dispatch(clearSynth());
  if (action.type === setNextSynth.type || action.type === removeFromSynth.type) {
    const indexes = store.getState().bloodline.synth;
    const souls = indexes.map(idx => idx === null ? undefined : store.getState().character.bloodlines.souls[idx]);
    if (indexes.includes(null) || new Set(indexes).size !== 3 || souls.some(soul => !soul) || !souls.every(soul => soul!.level === souls[0]!.level) || souls[0]!.level >= SERVER_CONFIG.BLOODLINE.Config.soulLevelLimits.length) {
      store.dispatch(setSynthResult(null));
    } else {
      store.dispatch(setSynthResult({ id: souls.every(soul => soul!.id === souls[0]!.id) ? souls[0]!.id : 0, level: souls[0]!.level + 1 }));
    }
  }
  return result;
};
